import createIcon from '../../createIcon';

/**
 * @component @name MoneyOff
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIuNDk5NiA2LjlDMTQuMjc5NiA2LjkgMTQuOTM5NiA3Ljc1IDE0Ljk5OTYgOUgxNy4yMDk2QzE3LjEzOTYgNy4yOCAxNi4wODk2IDUuNyAxMy45OTk2IDUuMTlWM0gxMC45OTk2VjUuMTZDMTAuNDY5NiA1LjI4IDkuOTY5NTcgNS40NiA5LjUxOTU3IDUuN0wxMC45ODk2IDcuMTdDMTEuMzk5NiA3IDExLjg5OTYgNi45IDEyLjQ5OTYgNi45Wk01LjMyOTU3IDQuMDZMNC4wNTk1NyA1LjMzTDcuNDk5NTcgOC43N0M3LjQ5OTU3IDEwLjg1IDkuMDU5NTcgMTEuOTggMTEuNDA5NiAxMi42OEwxNC45MTk2IDE2LjE5QzE0LjU3OTYgMTYuNjcgMTMuODY5NiAxNy4xIDEyLjQ5OTYgMTcuMUMxMC40Mzk2IDE3LjEgOS42Mjk1NyAxNi4xOCA5LjUxOTU3IDE1SDcuMzE5NTdDNy40Mzk1NyAxNy4xOSA5LjA3OTU3IDE4LjQyIDEwLjk5OTYgMTguODNWMjFIMTMuOTk5NlYxOC44NUMxNC45NTk2IDE4LjY3IDE1LjgxOTYgMTguMyAxNi40NDk2IDE3LjczTDE4LjY2OTYgMTkuOTVMMTkuOTM5NiAxOC42OEw1LjMyOTU3IDQuMDZaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const MoneyOff = createIcon('MoneyOff', [
  [
    'path',
    {
      d: 'M12.4996 6.9C14.2796 6.9 14.9396 7.75 14.9996 9H17.2096C17.1396 7.28 16.0896 5.7 13.9996 5.19V3H10.9996V5.16C10.4696 5.28 9.96957 5.46 9.51957 5.7L10.9896 7.17C11.3996 7 11.8996 6.9 12.4996 6.9ZM5.32957 4.06L4.05957 5.33L7.49957 8.77C7.49957 10.85 9.05957 11.98 11.4096 12.68L14.9196 16.19C14.5796 16.67 13.8696 17.1 12.4996 17.1C10.4396 17.1 9.62957 16.18 9.51957 15H7.31957C7.43957 17.19 9.07957 18.42 10.9996 18.83V21H13.9996V18.85C14.9596 18.67 15.8196 18.3 16.4496 17.73L18.6696 19.95L19.9396 18.68L5.32957 4.06Z',
      key: 'awhyry',
    },
  ],
]);

export default MoneyOff;
